import React from "react";
import { STATUS_COLOR } from "@/lib/status";

export default function StatusBadge({ status, showDot = true }) {
  const c = STATUS_COLOR[status] || STATUS_COLOR.Pending;
  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-md px-2 py-0.5 text-[11px] font-medium"
      style={{ background: c.bg, color: c.fg }}
    >
      {showDot && (
        <span className="ab-dot" style={{ background: c.dot }} aria-hidden />
      )}
      {c.label}
    </span>
  );
}

export function StatusDot({ status }) {
  const c = STATUS_COLOR[status] || STATUS_COLOR.Pending;
  return (
    <span
      className="inline-block h-2.5 w-2.5 rounded-full ring-2"
      style={{
        background: c.dot,
        boxShadow: `0 0 0 3px ${c.bg}`,
      }}
      aria-label={c.label}
    />
  );
}
